// extracted by mini-css-extract-plugin
module.exports = {"link":"InPageLink_link__3ByEE","arrow":"InPageLink_arrow__1WMrk","up":"InPageLink_up__OiJ0E"};